module.exports = __webpack_public_path__ + "img/error-icon.7ed08962.png";